import { ShoppingCart, Package, DollarSign } from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Badge } from "./ui/badge";
import { Separator } from "./ui/separator";
import { CatalogItem } from "../types/catalog";
import { Analogs } from "./Analogs";
import { ImageWithFallback } from "./figma/ImageWithFallback";

interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  description: string;
  stock: number;
  image: string;
}

interface ProductDetailDialogProps {
  product: CatalogItem  | null;
  isOpen: boolean;
  onClose: () => void;
  onAddToCart: (product: CatalogItem,storage: string,price:number ) => void;
}

export function ProductDetailDialog({
  product,
  isOpen,
  onClose,
  onAddToCart,
}: ProductDetailDialogProps) {
  if (!product) return null;
  const kv: Record<string, string> = Object.fromEntries(
    (product.props?.prop ?? []).map(p => [p.code, p.value])
  );
  const analoglist = kv['analog'] || '';
  const analog = kv['analog'] || '';
  const width = kv['width'] || '';
  const category = kv['category'] ;
  const model = kv['model'] || '';
  const pic='https://cdn.yutongoriginal.ru/product_images/'+product.code+'.jpg';
  const analogs = analoglist.split('/');
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl text-blue-900">{product.name}</DialogTitle>
          <DialogDescription>
            <Badge className="mt-2 bg-blue-100 text-blue-700">{category}</Badge>
          </DialogDescription>
        </DialogHeader>

        <div className="grid md:grid-cols-2 gap-6 mt-4">
          {/* Product Image */}
          <div className="aspect-square overflow-hidden rounded-lg">
            <ImageWithFallback
                                  src={pic}
                                  alt={product.name}
                                  className="object-cover hover:scale-105 transition-transform catalog_img"
                                />
          </div>
</div>
          {/* Product Details */}
          <div className="space-y-6">
            <div>
              <h3 className="text-sm font-semibold text-gray-500 uppercase mb-2">Применяемость</h3>
              <p className="text-gray-700">{model}</p>
            </div>
            <Analogs product={product} onAddToCart={function (product: CatalogItem): void {
                throw new Error("Function not implemented.");
              } } onViewDetails={function (product: CatalogItem): void {
                throw new Error("Function not implemented.");
              } }/>
            <Separator />

            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        {product.storage?.map(stock => (   
          <div className="flex items-center justify-between gap-4 pt-3 border-t border-gray-200">
            <div className="flex items-center gap-2 text-sm">
             <span>Склад {stock.storage}</span>  <Package className="h-4 w-4 text-gray-500" />
              <span className={stock.qty > 0 ? "text-green-600 font-medium" : "text-red-600 font-medium"}>
                {stock.qty > 0 ? `${stock.qty}` : 'под заказ'}
              </span>
            </div>
            <div className="flex items-center">
            <div className="text-xl font-bold text-blue-600 pr-3">{stock.price.toFixed(0)}₽</div>
            <Button 
              className="bg-gradient-to-br from-blue-950 to-blue-800 hover:bg-blue-700"
              onClick={(e) => {
                e.stopPropagation();
                onAddToCart(product,stock.storage,stock.price);
              }}
              disabled={stock.qty === 0}
            >
              <div className="text-right flex-shrink-0">
                
              </div>
              <ShoppingCart className="mr-2 h-4 w-4" />
              В корзину
            </Button>
          </div></div>
 ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
